import styles from './styles/SubTabs.module.scss';
import React, { useMemo, useState } from 'react';
import { SliderComponent } from '../../../../Components/react/SliderComponent';
import { getFilteredSubcollectionObjects } from '../../../utils/getFilteredSubcollectionObjects';
import { useAlgoliaDataContext } from '../../../hooks/useAlgoliaDataContext';
import { useHierarchyContext } from '../../../hooks/useHierarchyContext';
import { SubItems } from './SubItems';
import { dispatchGAEvent } from '../../../../events/dispatchGAEvent';
export const SubTabs = ({ itemHandles }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const { objects } = useHierarchyContext();
    const { facetsFromServer } = useAlgoliaDataContext();
    const items = useMemo(() => {
        setActiveIndex(0);
        return getFilteredSubcollectionObjects(itemHandles, facetsFromServer, objects);
    }, [itemHandles, objects, facetsFromServer]);
    const activeObj = items[activeIndex];
    return React.createElement(React.Fragment, null,
        React.createElement(SliderComponent, { sliderClass: styles.wrapper, showArrows: true, arrowsClass: styles.arrowButton },
            React.createElement("ul", { className: `list:none pos:r d:inline-flex w:100 ${styles.items}` }, items.map(({ handle, name, fullName }, index) => {
                return (React.createElement("li", { key: handle },
                    React.createElement("button", { className: `btn:cleared text:nowrap text:capitalize text:uppercase:xl-up pos:r ${styles.item} ${index === activeIndex ? `fw:700 ${styles.itemActive}` : ''}`, onClick: () => {
                            setActiveIndex(index);
                            dispatchGAEvent('Collection', 'click', `Subcollections : tab : ${fullName}`);
                        } }, name)));
            }))),
        activeObj !== undefined &&
            React.createElement(SubItems, { itemHandles: activeObj.children, viewAllObj: activeObj }));
};
